// Components
import { Box, Flex, Text } from "@chakra-ui/react"
import { Lottie } from "components"

export default function Done(){
    return(
    <>
    <Flex justifyContent="center" alignItems="center">
        <Box><Lottie animation="done" style={{ width: 200 }} /></Box>
        <Box maxW="40%">
            <Text fontSize="lg" fontWeight="bold" children="Pedido finalizado" />
            <Text color="GrayText">
                O pedido já passou por todas as etapas e foi retirado/enviado para o cliente.
            </Text>
        </Box>
    </Flex>
    </>
    )
}